import * as R from 'ramda';

const addCollectionIds = collectionIds => post => ({
    ...post,
    collectionIds: R.union(collectionIds, post?.collectionIds || []),
});

const addCollectionsToPosts = store => async (
    state,
    postIds,
    collectionIds,
) => {
    const userClientId = state.user.selectedUserClientId;

    store.setState(
        R.evolve(
            {
                clients: {
                    [userClientId]: {
                        media: {
                            posts: R.fromPairs(
                                postIds.map(postId => [
                                    postId,
                                    addCollectionIds(collectionIds),
                                ]),
                            ),
                        },
                    },
                },
            },
            store.getState(),
        ),
        true,
    );
};

export default addCollectionsToPosts;
